export interface DrillAndBlastDataInterface {
	chart: {
		type: string;
	};
	graph: {
		series: string;
	};
	series: Series[];
	title: { text: string;};
	tooltip: { title: string; categories: number[]};
	xAxis?: { title: string; categories: number[]};
	yAxis?: {text: string}
}

export interface Series {
	name: string;
	data: number[];
	type?: string;
	color?: string | Highcharts.GradientColorObject | Highcharts.PatternObject;
}

export interface FragmentationInterface {
  	muckpile?: [];
	fragmentationGraphData?: [];
}

export interface DrillDetailsInterface {
	loadingDesign?: [];
	drillLengthAndDiameter?: [];
	burdenAndSpacing?: [];
	holeCountAndLength?: [];
	pfAndTonData?: [];
}

export interface FielderAnalyticsInterface {
	drilledHolesByDrilledLength?: [];
	fielderAnalyticsData?: [];
	totalHolesAndTotalDrilledHolesByShot?: [];
	utilizationByShot?: [];
	drillGraph?: [];
}

export class FielderDataset {
	id: number;
	name: string;
	uuid: string;
}

export interface DrillAndBlastCostsInterface {
	drillAndBlastCostsGraphData?: [];
}

export interface InventoryInterface {
	inventoryGraphData?: [];
}

export interface ChartConfig{
	chartType: string;
  	widthClass?: string;
	title?: string;
}

export interface ChartDataInterface {
	siteId: number;
	datasetId: number;
	datasetName: string;
	holeCount: number;
	subdomainName: string;
	domainName: string;
	averageHoleDiameter: number;
	averageHoleLength: number;
	totalDrillingDepth: number;
	averagePatternBurden: number;
	averageSpacing: number;
	totalDrillLength: number;
	totalVolume: number;
	powderFactorVolume: number;
	datasetCreatedAt: string;
	subdomainId: number;
	domainId: number;
	siteName: string;
	noOfLabors: number;
	hours: number;
	trucks: null;
	createdAt: string;
}

export interface DataItem {
	color: string;
	name: string;
	data: number[];
}

export interface SeriesData {
	name: string,
	data: Array<any>,
	type?: string
}

export interface FineGoalParams {
	siteId: number;
	goalArray: {
		project: string;
		fines: number;
		finesGoal: number;
		muckpileTonnage: number;
		muckpileTonnageGoal: number;
	}[];
}

export interface utilizationGoalParams {
	siteId: number;
	goalArray: {
		project: string;
		utilization: number;
		utilizationGoal: number;
	}[];
}

export interface FineGoalDataInterface {
	project: string;
	fines: number;
	finesGoal: number; 
	datasetId: number;
	overSize: number;
	overSizeGoal: number;
	muckpile: number;
	muckpileGoal: number;
	tonsPerHour: number;
	tonsPerHourGoal: number;
}

export interface utilizationGoalDataInterface {
	project: string;
	utilization: number;
	utilizationGoal: number; 
	datasetId: number;
}

export interface designBurdenParams {
	designBurdenArray: {
		project: string;
		averageBurden: number;
		designBurden: number;
	}[];
}
